import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ADD_CPD_CATEGORY: (cpdCategory, icon) => ({ cpdCategory, icon }),
    API: {
      ADD_CPD_CATEGORY: apiResourceActionCreator('cpdCategory')
    }
  }
})

export const apiAction = (authToken, formData) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}/add-cpd-category`, authToken, formData, actions.admin.api.addCpdCategory);

function* addCpdCategory(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, {
    data: action.payload.cpdCategory,
    file: action.payload.icon
  }));

  const result = yield apiActionResult(actions.admin.api.addCpdCategory);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.cpdCategory }));
  }
}

const configuration = {
  name: 'addCpdCategory',
  action: actions,
  sagas: addCpdCategory,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true,
      error: undefined,
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/addCpdCategory.js